import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {tap} from "rxjs/operators";
import {DefaultService} from "../../../shared/_services/abstract/default.service";

@Injectable()
export class HelpService extends DefaultService {

    link: any;
    filters: any = {};
    onItemUpdate: BehaviorSubject<any>;
    onItemAdded: Subject<any>;
    onSearchTextChanged: Subject<any>;
    constructor(public override http: HttpClient,
    ) {
        super(http);
        this.setResourceLink('users/support');
        this.onItemUpdate = new BehaviorSubject([]);
        this.onSearchTextChanged = new Subject();
        this.onItemAdded = new Subject();

    }





}
